import React from "react";
import { Menu } from "antd";
import { NavLink } from "react-router-dom";
import { useAuthStore } from "../../store/auth";
import { useUserStore } from "../../store/user";

const LeftMenu = ({ mode }) => {
  const { isAuthenticated } = useAuthStore();
  const { permissions } = useUserStore();

  const menuItems = [
    {
      id: "home",
      url: "/",
      title: "Home",
      permissions: [],
      requiresAuth: false,
    },
    {
      id: "forums",
      url: "/forums",
      title: "Forums",
      permissions: ["user", "helper", "mod", "srmod", "admin", "god"],
      requiresAuth: true,
    },
    {
      id: "store",
      url: "https://store.cityliferp.net",
      title: "Store",
      permissions: [],
      requiresAuth: false,
    },
    {
      id: "admin",
      url: "/admin",
      title: "Admin Panel",
      permissions: ["helper", "mod", "srmod", "admin", "god"],
      requiresAuth: true,
    },
  ];

  const filteredMenuItems = menuItems.filter((item) => {
    if (item.requiresAuth && !isAuthenticated) return false;
    if (item.permissions.length === 0) return true;
    if (item.permissions.some((permission) => permissions.includes(permission)))
      return true;
    return false;
  });

  return (
    <Menu mode={mode}>
      {filteredMenuItems.map((item) => (
        <Menu.Item key={item.id} style={{ fontSize: '1.1em', fontWeight: '700' }}>
          <NavLink to={item.url}>{item.title}</NavLink>
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default LeftMenu;